import axios from 'axios';
// initial state
// shape: [{ id, quantity }]
const state = () => ({
    list : [],
    take : 25,
    columns: [
            {
                key : "name",
                label : "Name",
                setable: false,
                class: "is-2",
                display : true
            },
            {
                key : "description",
                label : "Description",
                display : true
            },
        ],
    loaded : false,
    loadingMore: false,
    loading: false,
    allLoaded : false,
    addNew : false,
    workingOn: [],
})

  // getters
  const getters = {
      isWorkingOn : (state) => (id) => {
          var index = state.workingOn.findIndex(id);
          if(index >= 0){
              return true;
          }else{
              return false;
          }
      }
  }

  // actions
  const actions = {
      async update({commit, state, rootState}, data){
          if(data.company_id == null || data.company_id == undefined){
              return;
          }
          await axios.put(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/companies/" + data.company_id + "/contacts/update", data.data).then(response => {
          })
      },
    async load({commit, state, rootState}, company_id){
        commit("isLoading", true);
            await axios.get(rootState.settings.url + "/api/v1/"+rootState.settings.internal.user_company +"/companies/"+ company_id +"/contacts", {params: {take: state.take, skip:state.list.length}}).then((response) => {
                commit("set", response.data.data);
                commit("isLoading", false);
            }).catch((error) => {
                console.log(error);
                commit("set", []);
                commit("isLoading", false);
            })
        commit("isLoading", false);
    },
  }

  // mutations
  const mutations = {
      set(state, list){
          if(list == undefined || list.length <= 0 || list.length <= state.take){
            state.allLoaded = true;
          }
          state.list = list;
      },
      unmount(state){
          state.allLoaded = false;
          state.loading = true;
          state.list = [];
          state.workingOn = [];
      },
      increasePage(state){
          state.loadingMore = true;
          state.page++;
      },
      isLoading(state, status){
          state.loadingMore = status;
          state.loading = status;
      }
  }

  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
    }
  }
